var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { staticClass: "pr-0", attrs: { cols: "8" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.shadowGroups,
                  "text-field": "name",
                  "value-field": "id",
                },
                on: { change: _vm.handleShadowGroupChange },
                scopedSlots: _vm._u([
                  {
                    key: "first",
                    fn: function () {
                      return [
                        _c("b-select-option", { attrs: { value: "" } }, [
                          _vm._v("\n            Create new group\n          "),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedShadowGroup,
                  callback: function ($$v) {
                    _vm.selectedShadowGroup = $$v
                  },
                  expression: "selectedShadowGroup",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-1", attrs: { cols: "4" } },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: {
                    title: !_vm.selectedPreset ? "Save" : "Update",
                    type: "button",
                    variant: "outline-primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("shadow-group-name-modal")
                    },
                  },
                },
                [
                  !_vm.selectedShadowGroup
                    ? _c("b-icon", { attrs: { icon: "save-fill" } })
                    : _c("b-icon", { attrs: { icon: "pencil-fill" } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedShadowGroup
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        title: "Delete",
                        type: "button",
                        variant: "outline-danger",
                      },
                      on: { click: _vm.deleteShadowGroup },
                    },
                    [_c("b-icon", { attrs: { icon: "bucket-fill" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("ShadowGroupNameModal", {
            attrs: {
              title: _vm.shadowGroupNameModal.title,
              value: _vm.shadowGroupNameModal.value,
              placeholder: "Please enter a shadow group name",
              "submit-btn-title": "Continue",
            },
            on: { submit: _vm.handleShadowGroupSubmit },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            {
              attrs: { card: "" },
              scopedSlots: _vm._u([
                {
                  key: "tabs-end",
                  fn: function () {
                    return [
                      _c(
                        "b-nav-item",
                        {
                          attrs: { href: "#", role: "presentation" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.newTab.apply(null, arguments)
                            },
                          },
                        },
                        [_c("b", [_vm._v("+")])]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "empty",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "text-center text-muted" }, [
                        _vm._v("\n          There are no open tabs"),
                        _c("br"),
                        _vm._v("\n          Open a new tab using the "),
                        _c("b", [_vm._v("+")]),
                        _vm._v(" button above.\n        "),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            _vm._l(_vm.tabs, function (shadow, key) {
              return _c(
                "b-tab",
                {
                  key: "key" + key,
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s("Shadow " + (key + 1)) +
                                "\n          "
                            ),
                            _c(
                              "b-button",
                              {
                                staticClass: "float-right close-button",
                                attrs: {
                                  pill: "",
                                  size: "sm",
                                  variant: "danger",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.closeTab(key)
                                  },
                                },
                              },
                              [_vm._v("\n            X\n          ")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n              Shadow Presets\n            "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            [
                              _vm.localShadows[_vm.tabIndex]
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      on: { change: _vm.onMirrorShadowChange },
                                      model: {
                                        value:
                                          _vm.localShadows[_vm.tabIndex]
                                            .disabled,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localShadows[_vm.tabIndex],
                                            "disabled",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "localShadows[tabIndex].disabled",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Temporarily disable shadow\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "pr-1", attrs: { cols: "6" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.shadowPresets,
                                      "text-field": "name",
                                      "value-field": "id",
                                    },
                                    on: {
                                      change: _vm.handleSelectPresetChange,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "first",
                                          fn: function () {
                                            return [
                                              _c(
                                                "b-select-option",
                                                { attrs: { value: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      create new\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.selectedPreset,
                                      callback: function ($$v) {
                                        _vm.selectedPreset = $$v
                                      },
                                      expression: "selectedPreset",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { staticClass: "p-0", attrs: { cols: "6" } },
                                [
                                  _vm.selectedPreset
                                    ? _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          attrs: {
                                            title: "Apply",
                                            type: "button",
                                            variant: "primary",
                                          },
                                          on: { click: _vm.applyPreset },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: { icon: "check-lg" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        title: _vm.selectedPreset
                                          ? `Edit`
                                          : "Save",
                                        type: "button",
                                        variant: "outline-primary",
                                      },
                                      on: {
                                        click: _vm.savePresetOfMirrorShadow,
                                      },
                                    },
                                    [
                                      !_vm.selectedPreset
                                        ? _c("b-icon", {
                                            attrs: { icon: "save-fill" },
                                          })
                                        : _c("b-icon", {
                                            attrs: { icon: "pencil-fill" },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.selectedPreset
                                    ? _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          attrs: {
                                            title: "Delete",
                                            type: "button",
                                            variant: "outline-danger",
                                          },
                                          on: { click: _vm.deletePreset },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: { icon: "bucket-fill" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Fade" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        max: 100,
                                        min: 0,
                                        type: "number",
                                      },
                                      on: { change: _vm.onMirrorShadowChange },
                                      model: {
                                        value: _vm.mirrorFade,
                                        callback: function ($$v) {
                                          _vm.mirrorFade = $$v
                                        },
                                        expression: "mirrorFade",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("b-input", {
                            attrs: { max: 100, min: 0, type: "range" },
                            on: { input: _vm.onMirrorShadowChange },
                            model: {
                              value: _vm.mirrorFade,
                              callback: function ($$v) {
                                _vm.mirrorFade = $$v
                              },
                              expression: "mirrorFade",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Opacity" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        max: 100,
                                        min: 0,
                                        type: "number",
                                      },
                                      on: { input: _vm.onMirrorShadowChange },
                                      model: {
                                        value: _vm.mirrorOpacity,
                                        callback: function ($$v) {
                                          _vm.mirrorOpacity = $$v
                                        },
                                        expression: "mirrorOpacity",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("b-input", {
                            attrs: { max: 100, min: 0, type: "range" },
                            on: { input: _vm.onMirrorShadowChange },
                            model: {
                              value: _vm.mirrorOpacity,
                              callback: function ($$v) {
                                _vm.mirrorOpacity = $$v
                              },
                              expression: "mirrorOpacity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "OffsetY" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        max: 500,
                                        min: -500,
                                        type: "number",
                                      },
                                      on: { input: _vm.onMirrorShadowChange },
                                      model: {
                                        value: _vm.mirrorOffsetY,
                                        callback: function ($$v) {
                                          _vm.mirrorOffsetY = $$v
                                        },
                                        expression: "mirrorOffsetY",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("b-input", {
                            attrs: { max: 500, min: -500, type: "range" },
                            on: { input: _vm.onMirrorShadowChange },
                            model: {
                              value: _vm.mirrorOffsetY,
                              callback: function ($$v) {
                                _vm.mirrorOffsetY = $$v
                              },
                              expression: "mirrorOffsetY",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }